// Opening fold — a single framed painting standing on the gallery floor, with
// oversized ghost lettering behind it and the artist's statement beneath.
export default function IntroPanel({ gallery }) {
  return (
    <section className="panel panel--intro" data-testid="hero-section">
      <span className="hall__floor-echo" aria-hidden="true" />

      <div className="intro__brandblock">
        <h1 className="intro__brand" data-testid="hero-brand">
          {gallery.artist_name}
        </h1>
        {gallery.hero_tagline && (
          <p className="intro__tagline mono-caps" data-testid="hero-tagline">{gallery.hero_tagline}</p>
        )}
      </div>

      <div className="ghost" aria-hidden="true">
        <span>{gallery.exhibition}</span>
      </div>

      <div className="intro__stage">
        <figure className="frame art-frame" data-cursor="View" data-testid="hero-image">
          <img src={gallery.hero_image} alt="Featured painting" draggable="false" />
        </figure>
      </div>

      <div className="intro__caption">
        <p className="intro__over mono-caps fade-up" style={{ "--d": "0.5s" }} data-testid="hero-overline">
          {gallery.hero_overline}
        </p>
        <p className="intro__statement fade-up" style={{ "--d": "0.65s" }} data-testid="statement-text">
          {gallery.statement}
        </p>
      </div>

      <div className="hero__enter mono-caps fade-up" style={{ "--d": "0.9s" }} aria-hidden="true" data-testid="scroll-cue">
        <span>Scroll to enter</span>
        <span className="hero__enter-line hero__enter-line--v" />
        <span className="hero__enter-arrow">&darr;</span>
      </div>
    </section>
  );
}
